import { render, staticRenderFns } from "./OrderStatusNewIcon.vue?vue&type=template&id=fbd2bef6&scoped=true&"
import script from "./OrderStatusNewIcon.vue?vue&type=script&lang=js&"
export * from "./OrderStatusNewIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd2bef6",
  null
  
)

export default component.exports